/**
 *
 * key
 *
 */

 const key = 'Y3Jvc3NQcm9tb3Rpb25zTGVhZA=='

 export default key
 